import type { GetStaticProps } from "next"
import { PageMeta } from "@/components/resources/components/Seo/PageMeta"
import {
  type CategoryPageProps,
  getSingleCategoryPageProps,
} from "@/components/resources/data/sanity/posts"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"

const Archive = ({ entries, categories, title, lead, category, meta }: CategoryPageProps) => {
  return (
    <>
      <PageMeta meta={meta} />
      <CategoryArchive
        entries={entries}
        categories={categories}
        category={category}
        title={title}
        lead={lead}
      />
    </>
  )
}

Archive.getLayout = SiteLayout

export default Archive

export const getStaticProps: GetStaticProps<CategoryPageProps> = async () => {
  const props = await getSingleCategoryPageProps("articles")

  if (!props) {
    return {
      props: {},
      notFound: true,
    }
  }

  return {
    props,
    revalidate: 180, // TODO: temporary to allow content editing without an hour wait for build
  }
}
